import { ContainerModule } from 'inversify';
import { GlobalProxy, createGlobalProxy, SmartFilterProxy, createSmartFilterProxy, PatentListProxy, createPatentListProxy, HiroEntryService, ContextProxy, createContextProxy, } from '@patsnap/hiro-event-proxy';
import { HiroEntryServiceImpl } from './services/imps/hiro-entry-service';
import { HiroBasicApi } from './apis/hiro-basic-api';
import { HiroBasicApiImpl } from './apis/impls/api';
import { GetSmartFilterResults } from './apis/get-smart-filter-results-api';
import { SmartFilterRepository } from './repositories/smart-filter-repository';
import { SmartFilterRepositoryImpl } from './repositories/impls/smart-filter-repository';
export const hiroModule = new ContainerModule((bind) => {
    // Event Proxy 单例 - 其他模块可以注入使用相同实例
    bind(GlobalProxy).toConstantValue(createGlobalProxy());
    bind(ContextProxy).toConstantValue(createContextProxy());
    bind(PatentListProxy).toConstantValue(createPatentListProxy());
    bind(SmartFilterProxy).toConstantValue(createSmartFilterProxy());
    // 绑定 Hiro API
    bind(HiroBasicApi).to(HiroBasicApiImpl).inSingletonScope();
    bind(GetSmartFilterResults).to(HiroBasicApiImpl).inSingletonScope();
    // 绑定 Smart Filter Repository
    bind(SmartFilterRepository).to(SmartFilterRepositoryImpl).inSingletonScope();
    // 绑定 Hiro Entry Service
    bind(HiroEntryService).to(HiroEntryServiceImpl).inSingletonScope();
});
